module.exports = __webpack_public_path__ + "static/media/empty.1afe6c95.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/vectors/empty.svg
// module id = 820
// module chunks = 0